import React, { Fragment, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { Tooltip } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);


    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        ItemCode: '',
        Name: '',
        Rate: '0',
        GSTRate: '0',
        Description: '',
        HSNCode: '',
        OpeningStock: '0',
        MinimumStock: '0',
        CreatedBy : userId,
        CreatedDate : new Date().toISOString(),
    });

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const submitData = async () => {
        try {
            // Fetch existing data
            const existingItems = await fetchData('ItemApi', `/${companyId}`, token);
            console.log('Existing Items:', existingItems);

            if (
                existingItems.response_data &&
                Array.isArray(existingItems.response_data) &&
                existingItems.response_data.some(
                    (item) => item.Name === formData.Name || item.ItemCode === formData.ItemCode
                )
            ) {
                alert('Item with the same Name or Code already exists.');
                return;
            }

            // Validate form data
            if (!formData || !formData.Name || !formData.ItemCode) {
                alert('Name and Code are required fields.');
                return;
            }

            // Submit data
            const response = await postData('ItemApi', formData, token);
            console.log('Data Created success:', response);

            history.push('/ItemIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Create</h6>

                        {/* <Button
                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder', marginTop: '-30px' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                        </Button>

                        <Button
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder', marginTop: '-30px' }}
                        >
                            <ReplyAllIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                        </Button> */}
                         <Tooltip title="Exit">
                                                    <Link to="/ItemIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                                        <Button style={{ color: 'brown', fontWeight: 'bolder', marginBottom: '10px' }}>
                                                            Back To List <ArrowForwardIosIcon />
                                                        </Button>
                                                    </Link>
                                                </Tooltip>
                                                <Tooltip title="SAVE">
                                                    <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder', marginLeft: '10px', marginTop: '-10px' }} disabled={isLoading}>
                                                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                                    </Button>
                                                </Tooltip>
                        

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                    <div className="w-full flex flex-wrap">
                        <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                            <div className="w-full mb-3 flex" >

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Code<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ItemCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="ItemCode"
                                        name='ItemCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/6 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Name<span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Name"
                                        name='Name'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Description
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Description}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Description"
                                        style={{ textAlign: 'left' }}
                                        name='Description'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                            </div>
                            <div className="w-full mb-3 flex" >
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.HSNCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="HSN Code"
                                        name='HSNCode'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Rate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Rate"
                                        style={{ textAlign: 'right' }}
                                        name='Rate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                         GST Rate{/*<span className="text-red-500">*</span> */}
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.GSTRate}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Rate"
                                        style={{ textAlign: 'right' }}
                                        name='GSTRate'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Opening Stock
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.OpeningStock}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Opening Stock"
                                        style={{ textAlign: 'right' }}
                                        name='OpeningStock'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Minimum Stock
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.MinimumStock}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Minimum Stock"
                                        style={{ textAlign: 'right' }}
                                        name='MinimumStock'
                                        onClick={(e) => e.target.select()}
                                    />
                                </div>
                            </div>

                        </div>

                    </div>

                </form >
            </div >
        </Fragment >
    );
};

export default ItemCreate;

